import { FlagIcon } from "@oysterhr/ui"
import { countryCodeToName } from "@oysterhr/common"
import classNames from "classnames"
import { ReactNode } from "react"

interface FlagAndCountryProps {
  className?: {
    countryName?: string
    flag?: string
  }
  countryCode: string
  countryName?: string
  extraInfo?: ReactNode | string | null
}

function FlagAndCountry({
  className = {},
  countryCode,
  countryName,
  extraInfo,
}: FlagAndCountryProps) {
  const cnFlag = classNames("w-6 mr-4", className.flag)
  const cnCountryName = classNames("font-medium text-base", className.countryName)
  return (
    <div className="flex items-center" data-testid="flag-and-country-container">
      <FlagIcon countryCode={countryCode} className={cnFlag} />
      <span className={cnCountryName} data-testid="country-name">
        {countryName || countryCodeToName(countryCode)}
        {extraInfo && <>{extraInfo}</>}
      </span>
    </div>
  )
}

export default FlagAndCountry
